'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Label = require('@narvar/nth-block-label');
var TextInput_module = require('./TextInput.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var Label__default = /*#__PURE__*/_interopDefaultLegacy(Label);

let SupportedInputType = /*#__PURE__*/function (SupportedInputType) {
  SupportedInputType["text"] = "text";
  SupportedInputType["password"] = "password";
  SupportedInputType["email"] = "email";
  SupportedInputType["number"] = "number";
  SupportedInputType["tel"] = "tel";
  SupportedInputType["search"] = "search";
  return SupportedInputType;
}({});
const TextInput = ({
  id,
  centered = false,
  animateLabel = false,
  label,
  name,
  title,
  type = SupportedInputType.text,
  disabled = false,
  value,
  autoComplete,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  minLength,
  maxLength,
  featureName,
  error = false,
  containerOverridesStyle,
  // for styling complex inputs with dropdowns (e.g., telephone input)
  className = '',
  inputRef,
  inputMode,
  ariaLabelledby,
  ariaDescribedBy
}) => {
  const [inputValue, setInputValue] = React.useState(value || '');
  const [inputActive, setInputActive] = React.useState(Boolean(value));
  const [animateState, setAnimateState] = React.useState(Label.LabelAnimateState.none);
  React.useEffect(() => {
    if (!animateLabel) return;
    setAnimateState(inputActive ? Label.LabelAnimateState.active : Label.LabelAnimateState.inactive);
  }, [inputActive, animateLabel]);
  React.useEffect(() => {
    setInputValue(value || '');
    setInputActive(Boolean(value));
  }, [value]);
  const {
    inputtextinputsNoneDisabled: inputStyleDisabled,
    inputtextinputsNoneFocus: inputStyleFocus,
    inputtextinputsNoneNone: inputStyle,
    inputtextinputsNoneError: inputStyleError
  } = nthHookTheme.useTheme();
  const inputClasses = clsx__default["default"]({
    [TextInput_module["default"].input]: true,
    [TextInput_module["default"].centeredStyle]: centered,
    [TextInput_module["default"].inputActive]: inputActive && label,
    [TextInput_module["default"].disabled]: disabled
  });
  const containerClasses = clsx__default["default"]({
    [className]: !!className,
    [TextInput_module["default"].container]: true
  });
  const style = {
    ...(disabled ? inputStyleDisabled : inputStyle),
    ...(inputActive ? inputStyleFocus : undefined),
    ...(error ? inputStyleError : undefined),
    ...containerOverridesStyle
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: containerClasses
  }, label && /*#__PURE__*/React__default["default"].createElement(Label__default["default"], {
    htmlFor: id,
    labelState: animateState,
    centered: centered,
    featureName: featureName,
    verticalAlign: Label.LabelVerticalAlign.middle
  }, label), /*#__PURE__*/React__default["default"].createElement("input", {
    className: inputClasses,
    id: id,
    style: style,
    name: name,
    title: title,
    type: type,
    autoComplete: autoComplete,
    disabled: disabled,
    value: inputValue,
    placeholder: placeholder,
    onChange: e => {
      setInputValue(e.target.value);
      if (onChange) onChange(e);
    },
    onFocus: () => {
      setInputActive(true);
      if (onFocus) onFocus();
    },
    onBlur: () => {
      setInputActive(Boolean(inputValue));
      if (onBlur) onBlur();
    },
    minLength: minLength,
    maxLength: maxLength,
    ref: inputRef,
    inputMode: inputMode,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": !!error
  }));
};
var TextInput$1 = nthHookTheme.withThemeProvider(TextInput, {
  themeTokens: ['inputtextinputsNoneDisabled', 'inputtextinputsNoneFocus', 'inputtextinputsNoneNone', 'inputtextinputsNoneError']
});

exports.SupportedInputType = SupportedInputType;
exports["default"] = TextInput$1;
